
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'BreastLobeTumor',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/BreastLobeTumor.vue